import { GoogleMap, Marker, MarkerClusterer, useJsApiLoader } from '@react-google-maps/api';
import {Row, Col} from 'react-bootstrap';
import {CONFIG} from "../utils/config";
import React, {useState} from "react";
import MapMarker from '../images/map_marker.png';
import MapMarkerYou from '../images/map_marker_you.png';
import CardItem from "./CardItem";


const MapDisplay = props => {

  const { allPosts, userLatLng, postcodeSearch } = props;

  const [map, setMap] = useState(null)
  const [allMarkers, setAllMarkers] = useState()
  const [userMarker, setUserMarker] = useState()
  const [activeMarker, setActiveMarker] = useState();

  // Add a tiny random factor to the position of markers so items in teh same location
  // don't appear as a single unclickable cluster of unreachable activities
  const offsetLatLngMax = .000055
  const offsetLatLngMin = -.000055

  const { isLoaded, loadError } = useJsApiLoader ({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_G_API_KEY
  })

  //https://googlemaps.github.io/v3-utility-library/interfaces/_google_markerclustererplus.clustericonstyle.html
  const clusterMarkerStyles = [
    {
      textColor: '#f79f3a',
      fontFamily: 'mr-eaves-xl-sans, sans-serif',
      fontWeight: 'bold',
      textSize: '18px',
      url: 'https://www.yowolves.co.uk/themes/custom/w_directory/images/m/m1.png',
      width: 38,
      height: 38
    },
    {
      textColor: '#f79f3a',
      fontFamily: 'mr-eaves-xl-sans, sans-serif',
      fontWeight: 'bold',
      textSize: '18px',
      url: 'https://www.yowolves.co.uk/themes/custom/w_directory/images/m/m2.png',
      width: 44,
      height: 44
    }
  ];

  const options = {
    clusterClass: 'mapCluster',
    minimumClusterSize: 3,
    maxZoom: 19,
    styles: clusterMarkerStyles
  };

  const CustomMarker = (props) => {
    const {item} = props;

    const onMarkerClick = () => {
      setActiveMarker(item);
    };

    return (
      <Marker
        onClick={onMarkerClick}
        {...props}
      />
    );
  }

  const onLoad = React.useCallback(function callback(map) {
    if (postcodeSearch) {
      setUserMarker(
        <CustomMarker
          position={userLatLng}
          title='Postcode location'
          clickable={false}
          zIndex={999}
          icon={{
            url: MapMarkerYou,
            anchor: new window.google.maps.Point(15, 40),
            scaledSize: new window.google.maps.Size(30, 40)
          }}
        >
        </CustomMarker>
      )
    }

    const bounds = new window.google.maps.LatLngBounds(CONFIG.MAP_INITIAL_LOCATION);

    if (allPosts.length > 0) {
      const markers = () => {
        return (
          <MarkerClusterer options={options}>
            {(clusterer) =>
              allPosts.map((item) => {
                if (item.attributes['field_latitude'] && item.attributes['field_longitude']) {
                  const offsetLat = parseFloat(item.attributes['field_latitude']) + (Math.random() * (offsetLatLngMax - offsetLatLngMin) + offsetLatLngMin)
                  const offsetLng = parseFloat(item.attributes['field_longitude']) + (Math.random() * (offsetLatLngMax - offsetLatLngMin) + offsetLatLngMin)

                  return (
                    <CustomMarker
                      className="map-marker"
                      key={item.attributes['drupal_internal__nid']}
                      item={item}
                      name={item.attributes.title}
                      title={item.attributes.title}
                      position={{
                        lat: offsetLat,
                        lng: offsetLng
                      }}
                      icon={{
                        url: MapMarker,
                        anchor: new window.google.maps.Point(15, 40),
                        scaledSize: new window.google.maps.Size(30, 40)
                      }}
                      clusterer={clusterer}
                    >
                    </CustomMarker>
                  )
                }
              })
            }
          </MarkerClusterer>
        )
      }
      setAllMarkers(markers)

      allPosts.forEach((item, i) => {
        if (item.attributes['field_latitude'] && item.attributes['field_longitude']) {
          const offsetLat = parseFloat(item.attributes['field_latitude']) + (Math.random() * (offsetLatLngMax - offsetLatLngMin) + offsetLatLngMin)
          const offsetLng = parseFloat(item.attributes['field_longitude']) + (Math.random() * (offsetLatLngMax - offsetLatLngMin) + offsetLatLngMin)
          bounds.extend({
            lat: offsetLat,
            lng: offsetLng
          })
        }
      });

    } else {
      bounds.extend(CONFIG.MAP_INITIAL_LOCATION)
    }

    map.fitBounds(bounds);
    setMap(map)
  }, [])

  const onUnmount = React.useCallback(function callback(map) {
    setMap(map)
  }, [])

  const closeCard = () => {
    setActiveMarker(null)
  }

  if (! isLoaded) {
    return <div>Loading...</div>
  } else {

    return (
      <div className="container map-card-container">
        {activeMarker && (
          <div className="map-card">
            <CardItem
              key={activeMarker.attributes['drupal_internal__nid']}
              data={activeMarker}
              postcodeSearch={postcodeSearch}
              hasClose={true}
              closeCard={closeCard}
            />
          </div>
        )}

        <Row className="map-display px-0">
          <Col className="map-container">
            <GoogleMap
              mapContainerStyle={{
                width: '100%',
                height: '100%'
              }}
              center={CONFIG.MAP_INITIAL_LOCATION}
              onLoad={onLoad}
              onUnmount={onUnmount}
              zoom={14}
            >
              { allMarkers }
              { userMarker }
            </GoogleMap>
          </Col>
        </Row>
      </div>
    )
  }
}

export default MapDisplay;
